import React from 'react';

import { NavbarPrimary, NavbarSecondary } from '../templates/sections';

const Header = (props) => {
  const { page, sanity } = props;
  return (
    <header id="header" className="fixed top-0 z-50 w-full shadow-lg">
      <NavbarSecondary page={page} sanity={sanity} />
      <NavbarPrimary page={page} sanity={sanity} />
    </header>
  );
};

export { Header };
